module.exports = __webpack_public_path__ + "img/account_mb_06.9a973624.png";